// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hXnMv","right":"styles_right__2NW7_"};